<i18n
  src="@/locales/components/views/agro_exporter/quality_control/container/show_inspect/quality_group_details.yml"
  lang="yaml"
></i18n>
<i18n
  src="@/locales/models/quality_general.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8 flex flex-col">
    <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div
          class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
        >
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell px-1 text-center">
                  {{ $t("labels.attribute") }}
                </th>
                <th class="table-header-cell text-center" scope="col">
                  {{ $t("labels.value") }}
                </th>
                <th
                  scope="col"
                  class="table-header-cell text-center"
                  v-if="show_total"
                >
                  {{ $t("labels.total") }}
                </th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                v-for="quality_attribute in quality_attributes"
                :key="quality_attribute.id"
                class="table-row divide-y"
              >
                <td class="table-cell-pos">
                  <div class="tooltip w-max">
                    <p class="text-center">
                      {{
                        quality_attribute?.abbreviation ||
                        quality_attribute?.crop_attribute?.name
                      }}
                    </p>
                    <span
                      v-if="quality_attribute.abbreviation"
                      class="tooltip-text"
                    >
                      {{ quality_attribute?.crop_attribute?.name }}
                    </span>
                  </div>
                </td>
                <td class="table-cell-main text-center px-1.5">
                  <p v-if="qualityAttributeIsContinous(quality_attribute)">
                    {{ getGeneralValue(quality_attribute) }}
                  </p>
                  <p v-else-if="qualityAttributeIsBoolean(quality_attribute)">
                    <i
                      v-if="getGeneral(quality_inspect, quality_attribute)?.value_bool"
                      class="fa-solid fa-check"
                    ></i>
                  </p>
                  <p v-else>
                    {{ getGeneralValue(quality_attribute) }}
                  </p>
                </td>
                <td class="table-cell-main text-center" v-if="show_total">
                  <p v-if="quality_group.calculate_percentages">
                    {{
                      getGeneral(quality_inspect, quality_attribute)
                        ?.percent_total_by_group
                        ? `${
                            getGeneral(quality_inspect, quality_attribute)
                              ?.percent_total_by_group
                          }%`
                        : " "
                    }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsMixin from "@/components/views/mixins/agro_exporter/quality_control/container/show_inspect/quality_group_details.js";
import QualityAttributeMixin from "@/components/views/mixins/models/quality_attribute.js";

export default {
  mixins: [DetailsMixin, QualityAttributeMixin],
  methods: {
    getGeneralValue: function (quality_attribute) {
      return this.getGeneral(this.quality_inspect, quality_attribute)?.value;
    },
  },
};
</script>

<style>
</style>
